export function useSearchOptions() {
  const searchOptions = [
    // Páginas principales
    {
      label: "Dashboard",
      value: "dashboard",
      route: "/dashboard",
      category: "pages",
      icon: "objects",
    },
    {
      label: "Pedir lentes",
      value: "pedir-lentes",
      route: "/pedir-lentes/datos-basicos",
      category: "pages",
      icon: "eye",
    },
    {
      label: "Estado de pedidos",
      value: "estado-pedidos",
      route: "/lentes/pedidos",
      category: "pages",
      icon: "eye",
    },
    {
      label: "Recetas guardadas",
      value: "recetas-guardadas",
      route: "/lentes/recetas-guardadas",
      category: "pages",
      icon: "bookmark",
    },
    {
      label: "Recogidas",
      value: "recogidas",
      route: "/lentes/recogidas",
      category: "pages",
      icon: "delivery-truck-pin",
    },
    {
      label: "Devoluciones",
      value: "devoluciones",
      route: "/lentes/devoluciones",
      category: "pages",
      icon: "bin-box-arrow-up",
    },
    {
      label: "Bienes de equipo",
      value: "bienes-equipo",
      route: "/bienes-de-equipo",
      category: "pages",
      icon: "gears",
    },
    {
      label: "Notificaciones",
      value: "notificaciones",
      route: "/notificaciones",
      category: "pages",
      icon: "notifications",
    },
    {
      label: "Facturación",
      value: "facturacion",
      route: "/theme/facturacion",
      category: "pages",
      icon: "check-document",
    },
    {
      label: "Formación",
      value: "formacion",
      route: "/theme/formacion",
      category: "pages",
      icon: "graduation-cap",
    },
    {
      label: "Marketing",
      value: "marketing",
      route: "/theme/marketing",
      category: "pages",
      icon: "thumbs-up",
    },
    // Ajustes
    {
      label: "Datos ópticos",
      value: "datos-opticos",
      route: "/settings/optic-data",
      category: "ajustes",
      icon: "eye",
    },
    // {
    //   label: "Buscador web",
    //   value: "busqueda-web",
    //   route: "/settings/websearch",
    //   category: "ajustes",
    //   icon: "search",
    // },
    {
      label: "Buzón",
      value: "buzon",
      route: "/settings/mailbox",
      category: "ajustes",
      icon: "document-edit-pen",
    },
    {
      label: "Calibración monitor",
      value: "calibracion-monitor",
      route: "/settings/calibration-monitor",
      category: "ajustes",
      icon: "settings",
    },
    {
      label: "Plotters",
      value: "plotters",
      route: "/settings/plotters",
      category: "ajustes",
      icon: "gears",
    },
    {
      label: "Favoritos",
      value: "favoritos",
      route: "/settings/favorites",
      category: "ajustes",
      icon: "bookmark-favorite",
    },
    {
      label: "Configuración",
      value: "configuracion-indonet",
      route: "/settings/configuration-indonet",
      category: "ajustes",
      icon: "settings-nav",
    },
    {
      label: "Perfil",
      value: "perfil",
      route: "/myprofile",
      category: "ajustes",
      icon: "user",
    },
  ];

  // Acciones rápidas
  const quickActions = [
    {
      label: "Cerrar sesión",
      value: "cerrar-sesion",
      category: "actions",
      icon: "logout",
      action: "logout",
      description: "Finaliza tu sesión actual",
      requiresInput: false,
    },
    {
      label: "Buscar pedido",
      value: "buscar-pedido",
      category: "actions",
      icon: "search",
      action: "searchOrder",
      placeholder: "Ej: 12345 o REF123",
    },
    {
      label: "Duplicar pedido",
      value: "duplicar-pedido",
      category: "actions",
      icon: "download-arrow",
      action: "duplicateOrder",
      placeholder: "Ej: número de pedido",
    },
    {
      label: "Duplicar receta",
      value: "duplicar-receta",
      category: "actions",
      icon: "bookmark",
      action: "duplicateRecipe",
      placeholder: "Ej: número de receta",
    },
    {
      label: "Imprimir pedido",
      value: "imprimir-pedido",
      category: "actions",
      icon: "printer",
      action: "printOrder",
      placeholder: "Ej: número de pedido o referencia",
    },
    {
      label: "Pedido actual",
      value: "pedido-actual",
      category: "actions",
      icon: "eye",
      action: "showCurrentOrder",
      requiresInput: false,
    },
  ];

  return {
    searchOptions,
    quickActions,
  };
}
